<template>
  <div class="d-2304">
    <v-layout class="round-block font-size--18 font-weight-bold mb-2">
      <v-flex>누적 사입비</v-flex>
      <v-flex class="color--primary-100">
        <TotalSummaryAmount :loading="loading" :amount="data.totalPayment" />
      </v-flex>
    </v-layout>
    <section class="round-block color--gray-70">
      <v-row no-gutters>
        <v-col>플랫폼 입금</v-col>
        <v-col><TotalSummaryAmount :loading="loading" :amount="data.totalMallDeposit" /></v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>누적 상환금</v-col>
        <v-col><TotalSummaryAmount :loading="loading" :amount="data.totalRepayment" /></v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>남은 상환금</v-col>
        <v-col><TotalSummaryAmount :loading="loading" :amount="data.remainRepayment" /></v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>셀러 반환</v-col>
        <v-col><TotalSummaryAmount :loading="loading" :amount="data.totalRefund" /></v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import TotalSummaryAmount from './TotalSummaryAmount.vue'

export default {
  components: { TotalSummaryAmount },
  data() {
    return {
      loading: false,
      data: {},
    }
  },
  async created() {
    this.loading = true
    try {
      const { data } = await this.getTotalAmount()
      this.data = data
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions('bnpl', ['getTotalAmount']),
  },
}
</script>

<style lang="scss" scoped>
.row,
.layout {
  .col:last-child,
  .flex:last-child {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

section .row:not(:last-child) {
  margin-bottom: 5px;
}
</style>
